import { render, staticRenderFns } from "./ArrowBack.vue?vue&type=template&id=10d33b5c&"
import script from "./ArrowBack.vue?vue&type=script&lang=ts&"
export * from "./ArrowBack.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports